import React from 'react'
import { Formik } from 'formik'
import * as Yup from 'yup'

import ecbrApi from '../../../../services/ecbrApi'
import { Form, FormBody } from '../../../../components/Form/styles'

import { Button } from '../../../../components'
import Input from '../../../../components/Form/Input'
import SelectAsync from '../../../../components/Form/SelectAsync'
import { ButtonContainer } from './styles'

const initialValues = {
  brand: null,
  Loja: null,
  startDate: '',
  endDate: ''
}

const formSchema = Yup.object().shape({
  brand: Yup.number()
    .transform((_, obj) => obj?.value ?? null)
    .nullable(),
  certification: Yup.number()
    .transform((_, obj) => obj?.value ?? null)
    .nullable(),
  startDate: Yup.string().optional(),
  endDate: Yup.string().when('startDate', (startDate, schema) =>
    startDate
      ? schema.test(
          'endDate',
          'Data fim deve ser maior que a data início',
          (endDate) => !endDate || endDate > startDate
        )
      : schema
  )
})

const loadBrandOptions = async (inputValue) => {
  const { data } = await ecbrApi.brands.getActualCompanyBrands({
    brandName: inputValue
  })
  const brands = data.data.map(({ id, brandName }) => ({
    value: id,
    label: brandName
  }))
  return brands
}

const loadProductOptions = async () => {
  const { data } = await ecbrApi.products.getAll()
  const products = data.map(({ id, name }) => ({
    value: id,
    label: name
  }))
  return products
}

const PaymentsFilters = ({ setFilters }) => {
  const onSubmit = async ({ brand, certification, startDate, endDate }) => {
    setFilters({
      ...(brand?.value && { brandId: brand.value }),
      ...(certification?.value && { productId: certification.value }),
      ...(startDate && { startDate: startDate }),
      ...(endDate && { endDate: endDate })
    })
  }

  const handleCleanFilters = (setFieldValue) => () => {
    setFilters({})
    setFieldValue('brand', null)
    setFieldValue('certification', null)
    setFieldValue('startDate', '')
    setFieldValue('endDate', '')
  }

  return (
    <span>
      <Formik
        initialValues={initialValues}
        validationSchema={formSchema}
        onSubmit={onSubmit}
      >
        {({ isSubmitting, setFieldValue }) => (
          <Form maxWidth="100%" margin="0">
            <FormBody type="flex" flexRow justifyContent="flex-start">
              <SelectAsync
                name="brand"
                label="Loja"
                loadOptions={loadBrandOptions}
                optionValue="value"
                optionLabel="label"
                width="184px"
                fontSizeLabel="12px"
              />
              <SelectAsync
                name="certification"
                label="Certificação"
                loadOptions={loadProductOptions}
                optionValue="value"
                optionLabel="label"
                width="184px"
                fontSizeLabel="12px"
              />
              <Input
                type="date"
                name="startDate"
                label="Data início"
                width="184px"
                placeholder="Selecione"
              />
              <Input
                type="date"
                name="endDate"
                label="Data fim"
                width="200px"
                placeholder="Selecione"
              />
              <ButtonContainer>
                <Button
                  text="Filtrar"
                  type="submit"
                  variant="primary"
                  width="120px"
                  disabled={isSubmitting}
                />
                <Button
                  text="Limpar"
                  type="button"
                  variant="outlined"
                  width="120px"
                  disabled={isSubmitting}
                  onClick={handleCleanFilters(setFieldValue)}
                />
              </ButtonContainer>
            </FormBody>
          </Form>
        )}
      </Formik>
    </span>
  )
}

export default PaymentsFilters
